import { render, staticRenderFns } from "./child.vue?vue&type=template&id=0d4de9f2&scoped=true"
import script from "./child.vue?vue&type=script&lang=js"
export * from "./child.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4de9f2",
  null
  
)

export default component.exports